import { Wifi, Clock, AlertTriangle } from 'lucide-react'

export function ProviderIcon({ providerType, className = 'h-5 w-5 text-muted-foreground' }: { providerType: string; className?: string }) {
  switch (providerType) {
    case 'reservation':
      return <Wifi className={className} />
    case 'fuel_pos':
      return <Clock className={className} />
    default:
      return <AlertTriangle className={className} />
  }
}
